<template>
  <div v-loading="loading">
    <div v-if="selectShareGoods">
      <div class="selectInfoWrap">
        <span class="typeText">类型</span>
        <form action="">
          <el-select v-model="selectType" size="small" style="width: 100px">
            <el-option label="全部" value="all"> </el-option>
            <el-option label="文章" value="article"> </el-option>
            <el-option label="产品" value="product"> </el-option>
          </el-select>
          <el-button
            class="selectBtn"
            icon="el-icon-search"
            type="primary"
            @click="getNoShareGoods"
            size="small"
            >查询</el-button
          >
        </form>
      </div>

      <!-- 表格数据 -->
      <el-table :data="tableData" class="shareProducts">
        <el-table-column
          align="center"
          property="product_name"
          label="标题"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          property="type"
          label="分类"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          property="create_time"
          label="创建时间"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          property="option"
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="chooseGoods(scope.row)"
              >选择</el-button
            >
            <!-- <el-button type="text" size="small">编辑</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          class="paginates"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="curPage"
          :page-size="pageSize"
          layout="prev, pager, next,jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <div v-if="addShareGoods">
      <el-form
        label-position="left"
        :model="selectData"
        ref="form"
        label-width="100px"
        class="select-form"
        @submit.native.prevent
      >
        <el-form-item label="Id：" style="display: none">
          <span>{{ needAddGoods.id }}</span>
        </el-form-item>
        <el-form-item label="类型：">
          <span>{{ needAddGoods.type }}</span>
        </el-form-item>
        <el-form-item label="标题：">
          <span>{{ needAddGoods.title }}</span>
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="selectData.status">
            <el-radio :label="1">正常商品</el-radio>
            <el-radio :label="0">分享商品</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="收益模式">
          <el-radio-group v-model="selectData.reward_model">
            <el-radio :label="1">一级分享</el-radio>
            <el-radio :label="2">二级分享</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="分享推荐">
          <el-radio-group v-model="selectData.is_share">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="奖励类型">
          <el-radio-group v-model="selectData.reward_type">
            <el-radio :label="1">红包</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="奖励总数" :inline="true">
          <el-input
            style="width: 340px"
            v-model="selectData.reward_total"
            placeholder="请输入奖励总数"
          ></el-input>
        </el-form-item>

        <el-form-item label="一级分享范围" inline="true">
          <div class="rewardArea">
            <el-input
              style="width: 150px"
              v-model="selectData.reward_min_first"
              placeholder="请输入奖励的最小值"
            ></el-input>
            <span style="margin: 0 10px">至</span>
            <el-input
              style="width: 150px"
              v-model="selectData.reward_max_first"
              placeholder="请输入奖励的最大值"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="二级分享范围" inline="true">
          <div class="rewardArea">
            <el-input
              style="width: 150px"
              v-model="selectData.reward_min_second"
              placeholder="请输入奖励的最小值"
            ></el-input>
            <span style="margin: 0 10px">至</span>
            <el-input
              style="width: 150px"
              v-model="selectData.reward_max_second"
              placeholder="请输入奖励的最大值"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="有效时间">
          <el-date-picker
            v-model="selectData.effective_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBtn">取 消</el-button>
        <el-button type="primary" @click="AddBtn">确 定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import ShareApi from "@/api/sharepolite.js";

export default {
  data() {
    return {
      selectShareGoods: true,
      addShareGoods: false,
      loading: true,
      pageSize: 1,
      curPage: 1,
      selectType: "all",
      tableData: [],
      selectData: {
        status: "",
        reward_model: "",
        is_share: "",
        reward_type: "",
        reward_total: "",
        effective_time: "",
        reward_min_first: "",
        reward_max_first: "",
        reward_max_second: "",
        reward_max_second: "",
      },
      total: 0,
      // 需要添加的商品id
      needAddGoods: {},
    };
  },
  props: [],
  created() {
    this.getNoShareGoods();
  },
  methods: {
    // 取消按钮
    cancelBtn() {
      this.selectShareGoods = true;
      this.addShareGoods = false;
      this.selectData = {};
    },
    // 添加按钮
    AddBtn() {
      let params = {
        setting: this.selectData,
        info: this.needAddGoods,
      };
      ShareApi.addShareGoods(params, true).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success",
            duration:1500
          });
          setTimeout(()=>{
            this.$router.go(0);
          },1500)
        }
        console.log(res);
      });
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getsharerecords();
    },
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getsharerecords();
    },
    // 显示类型未为分享商品列表
    getNoShareGoods() {
      let params = { type: this.selectType };
      this.$loading = ShareApi.queryNoShareGoods(params, false).then((res) => {
        console.log(res.data.data);
        this.loading = false;
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.curPage = res.data.data.current_page;
        this.pageSize = res.data.data.per_page;
      });
    },
    // 显示类型未为分享商品设置页面
    chooseGoods(e) {
      let id = e.type == "产品" ? e.product_id : e.id;
      this.needAddGoods = { id: id, type: e.type, title: e.product_name };
      this.selectShareGoods = false;
      this.addShareGoods = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.selectInfoWrap {
  display: flex;
  align-items: center;
}
.typeText {
  margin-right: 16px;
}
.selectBtn {
  margin-left: 16px;
}
.paginates,
.shareProducts {
  margin-top: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/sharepolite/addGoods/selectInfo.vue